import React, { useCallback, useMemo } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';
import get from 'lodash/get';
import orderBy from 'lodash/orderBy';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints.js';

// HELPERS
import { documentChunkFetch, makePath, getFileType, shouldOpenFile, viewFile } from 'functions';

// CORE COMPONENTS
import Button from 'core/tools/Button';

// MAIN COMPONENT
const DownloadRecentButton = ({ name }) => {

  // FORMIK
  const { values } = useFormikContext() || {};

  // MEMOS
  const attachments = useMemo(
    () => get(values, name),
    [name, values]
  )
  const recentUpload = useMemo(
    () => orderBy(attachments, a => new Date(a.date_updated || '').getTime(), 'desc')[0] || null,
    [attachments]
  )

  // CALLBACKS
  const handleDownloadRecent = useCallback(
    () => {
      const { fileName, salesattachment_filename = fileName, salesattachment_id, temp_attachment_id } = recentUpload;
      const mimeType = getFileType(salesattachment_filename);
      documentChunkFetch({
        endpoint: !salesattachment_id ? makePath(ENDPOINTS.uploads.temp.view, temp_attachment_id) : makePath(ENDPOINTS.uploads.sales.view, salesattachment_id),
        mimeType,
        loadingMessage: shouldOpenFile(mimeType) ? 'Opening file' : 'Downloading file',
        errorMessage: 'Unable to download file.',
        onSuccess: r => viewFile({ ...r, fileName: salesattachment_filename}),
      });
    },
    [recentUpload]
  )

  // RENDER
  return attachments?.length > 1 ? (
    <Button
      className="mt-3 mt-sm-0 ms-sm-4"
      label="Download Most Recent"
      onClick={handleDownloadRecent}
      outline
      fullWidth={false}
    />
  ) : null;
}

// EXPORT
export default DownloadRecentButton;